import React from 'react';
import { PropTypes } from 'prop-types';
import styled, { css } from 'styled-components';

const Expand = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  background: ${({ theme, background, overwriteGlobal }) =>
    `${background} ${overwriteGlobal ? '!important' : ''}` ||
    `${theme.iconColor} ${overwriteGlobal ? '!important' : ''}`};
  border-color: ${({ theme, borderColor }) => borderColor || theme.iconColor};
  color: ${({ color }) => color || 'white'};
  cursor: ${({ cursor }) => cursor || 'pointer'};
  font-size: ${({ fontSize }) => fontSize || '16px'};
  font-weight: ${({ fontWeight }) => fontWeight || 'bold'};
  height: ${({ height }) => height || '100%'};
  text-align: ${({ textAlign }) => textAlign || 'center'};
  text-transform: ${({ textTransform }) => textTransform || 'uppercase'};
`;

const Container = styled.div`
  background: ${({ borderColor }) => borderColor || 'transparent'};
  box-sizing: border-box;
  display: table-cell;
  line-height: 100%;
  width: ${({ width }) => width || '85px'};
  height: ${({ height }) => height || '48px'};
  padding: ${({ padding }) => padding || '0'};
  margin: ${({ margin }) => margin || '0'};

  @media screen and (max-width: 580px) {
    display: block;
    width: ${({ mobileWidth }) => mobileWidth || '85px'};
    height: ${({ mobileHeight }) => mobileHeight || '48px'};
    padding: ${({ mobilePadding }) => mobilePadding || '0'};
    margin: ${({ mobileMargin }) => mobileMargin || '0'};
  }
`;

const TableButton = props => (
  <Container onClick={props.onClick} {...props.outerProps}>
    <Expand {...props.innerProps}>{props.children}</Expand>
  </Container>
);

TableButton.propTypes = {
  onClick: PropTypes.func,
  innerProps: PropTypes.object,
  outerProps: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
};

TableButton.defaultProps = {
  onClick: () => null,
  innerProps: {},
  outerProps: {},
};

export default TableButton;
